<template>
    <div>  
      <egg-description
        title="naviVaccination.naviVaccinationAdult"
        titleColor="#603813"
        :starIconObj="{ componentName: 'shared', imgName: 'starIconPurple', imgFormat: 'svg' }"
        :eggImgObj="{ componentName: 'naviVaccination', imgName: 'vacAdult', imgFormat: 'svg', position: 'right' }"
        :starBackgroundRightObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleRight', imgFormat: 'svg', top: '-20%' }"
        :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleLeft', imgFormat: 'svg', bottom: '-20%' }"
        textMode="paragraph"
        :description="vaccinationStore.vacAdultType"
        class="pb-36"
      />
    </div>
  </template>
  
  <script setup lang="ts">
  import { useVaccinationStore } from "@/stores/naviVaccination";
  import { computed, onMounted, ref, toRefs } from "vue";
  import { useRouter } from "vue-router";
  
  const vaccinationStore = useVaccinationStore();
  const router = useRouter();
  
  onMounted(async () => {});
  
  //not on home page, stop intro timer
  router.beforeEach(async (to, from) => {});
  
  const goTo = (refName) => {};
  
  const routeTo = (position) => {
    router.push({ name: position, params: { uid: "lczmx" } });
  };
  </script>